import {buildResponsiveImageData} from 'Shared/buildResponsiveImageData';

import type {Media} from 'types/payload-types';

const IMAGE_WIDTH = 1200;

/**
 * Builds the responsive image data used by the editorial image block.
 *
 * @param image A populated media document or relation ID.
 * @returns Responsive image data or null when no populated image is available.
 */
export const useImageBlock = (image: Media | string | null | undefined) => (
    typeof image === 'object' && image !== null
        ? buildResponsiveImageData(image, IMAGE_WIDTH)
        : null
);